'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = preloader;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
    show: false
};

function preloader() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (action.show_preloader || action.type === 'reduxAsyncConnect/BEGIN_GLOBAL_LOAD') {
        return (0, _extends3.default)({}, state, {
            show: true
        });
    } else if (state.hide_preloader || action.type === 'reduxAsyncConnect/END_GLOBAL_LOAD') {
        return (0, _extends3.default)({}, state, {
            show: false
        });
    }

    return state;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/reducers/preloader.js
// module id = 1911
// module chunks = 0